<template>
  <div>
    <main-content>
      <div class="h3">{{ $t('enamad_services.enamad_register') }}</div>
      <div class="bg-white shadow-sm p-5 my-3" style="border-radius: 10px">
        <!-- failed -->
          <enamad-failed v-if="enamad_fail" :shop_id="shop_id"></enamad-failed>
        <!-- success -->
          <enamad-success v-if="enamad_success" :enamad_code="enamad_code"></enamad-success>
          <!-- pending -->
          <enamad-code-pending v-if="enamad_code_pending" :shop_id="shop_id"></enamad-code-pending>
      </div>
    </main-content>
  </div>
</template>

<script>
import MainContent from "@/components/main-content";
import { enamadServices } from "@/common/api.service";
import enamadFailed from './paymentRedirect/enamadFailed.vue';
import enamadSuccess from './paymentRedirect/enamadSuccess.vue';
import enamadCodePending from './paymentRedirect/enamadCodePending.vue';
export default {
  name: "EnamdPayment",
  data() {
    return {
      enamad_data: {},
      show_error: false,
      error: "",
      enamad_fail: false,
      enamad_success: false,
      enamad_code_pending: false,
      shop_id: "",
      enamad_code: ""
    };
  },
  components: {
    MainContent,
    enamadFailed,
    enamadSuccess,
    enamadCodePending
  },
  mounted() {
    enamadServices.getStatusCode(this.$route.params.id)
      .then((response) => {
          this.enamad_code = response.data.data['e-namad_code']
          this.enamad_success = true
      })
      .catch(({response}) => {
          this.shop_id = (response.data.data.shop_id)
          if(!response.data.data.payment_status && response.data.data['e-namad_code'] === null){
            this.enamad_fail = true
          }
          if(response.data.data.payment_status && response.data.data['e-namad_code'] === null){
            this.enamad_code_pending = true
          }
      });
  },
};
</script>

<style scoped>
.code_enamad {
  background: #f1f1f1;
  color: #333;
  padding: 0.1rem 0.4rem;
  margin: 0 0.5rem;
  border-radius: 5px;
}
</style>
